import React, { FC } from 'react'

import { PageContent } from 'common'
import { InterSvgIcon } from 'components'
import { Button } from 'common/styles/layouts'

import { Text } from '@interco/inter-ui/components/Text'

import { MainContent } from '../styles/UnavailableService.styles'
import { TUnavailableServiceView } from '../types/UnavailableService.types'

export const UnavailableServiceView: FC<TUnavailableServiceView> = ({
  details,
  icon,
  title,
  label,
  onClose,
}) => (
  <PageContent>
    <MainContent>
      <InterSvgIcon
        iconRef={icon ?? 'core/status/ic_close_circle_fill'}
        height={64}
        width={64}
        color="var(--orange500)"
      />
      <Text variant="headline-h1" color="typography" semiBold>
        {title}
      </Text>
      <Text variant="body-3">{details}</Text>
    </MainContent>
    <Button variant="primary" style={{ marginBottom: '1rem' }} onClick={onClose}>
      {label}
    </Button>
  </PageContent>
)
